import { render, staticRenderFns } from "./Pagamentos2.vue?vue&type=template&id=249a2aa6"
import script from "./Pagamentos2.vue?vue&type=script&lang=js"
export * from "./Pagamentos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports